// dependencies
import emailjs from "@emailjs/browser"

// config
import { EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, EMAILJS_PUBLIC_KEY } from "./emailJsConfig"


export const sendEmail = async (formData, successCallback, errorCallback) => {
    try {
        await emailjs.send(
            EMAILJS_SERVICE_ID,
            EMAILJS_TEMPLATE_ID,
            formData,
            { publicKey: EMAILJS_PUBLIC_KEY }
        )
        successCallback()
    } catch (error) {
        errorCallback(error)
    }
}


